import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../../images/circle-info-regular-full.svg'

function UPC ({ localGTIN, setLocalGTIN, isQueryLoading }) {
  const handleGTINChange = event => {
    setLocalGTIN(event.target.value)
  }

  return (
    <div className={styles.UPCContainerPeople}>
      <div className={styles.inlineLabel}>
        <label className={styles.UPCPeopleLabel} htmlFor='UPC'>
          UPC or GTIN
        </label>
        <Tooltip
          title='Filter by the product’s UPC or GTIN code.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='UPC/GTIN help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <input
        className={styles.UPCInputPeople}
        disabled={isQueryLoading}
        placeholder='Text'
        onChange={handleGTINChange}
        value={localGTIN}
        type='text'
      />
    </div>
  )
}

export default UPC
